import React from 'react';
import PropTypes from 'prop-types';
import { getTokensPropType } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const CarouselContext = /*#__PURE__*/React.createContext();
const CarouselProvider = _ref => {
  let {
    activeIndex,
    children,
    goTo,
    getCopyWithPlaceholders,
    itemLabel,
    refocus = false,
    themeTokens,
    totalItems,
    width,
    maximumItemsForSlide
  } = _ref;
  const value = React.useMemo(() => ({
    activeIndex,
    goTo,
    getCopyWithPlaceholders,
    itemLabel,
    refocus,
    themeTokens,
    totalItems,
    width,
    maximumItemsForSlide
  }), [activeIndex, goTo, getCopyWithPlaceholders, itemLabel, refocus, totalItems, themeTokens, width, maximumItemsForSlide]);
  return /*#__PURE__*/_jsx(CarouselContext.Provider, {
    value: value,
    children: children
  });
};
function useCarousel() {
  const context = React.useContext(CarouselContext);
  if (context === undefined) {
    throw new Error(`'useCarousel' must be used within a 'CarouselProvider'`);
  }
  return context;
}
CarouselProvider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  activeIndex: PropTypes.number.isRequired,
  goTo: PropTypes.func.isRequired,
  getCopyWithPlaceholders: PropTypes.func.isRequired,
  itemLabel: PropTypes.string.isRequired,
  refocus: PropTypes.bool,
  themeTokens: getTokensPropType('Carousel'),
  totalItems: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  maximumItemsForSlide: PropTypes.number
};
export { CarouselProvider, useCarousel };